function o({
  tone: n,
  emphasis: t,
  onHighEmphasisSurface: e
}) {
  return e ? `contentOn-${n}-high-surface` : `${n}-${t}-content`;
}
export {
  o as getToneContentColorRole
};
